<template>
<!-- <div> -->
<div :id="editorId" ref="editor"></div>
<!-- </div> -->
</template>

<script>
import uploadImg from '@/utils/editorUpload';
import {
    getFileToken,
    imageUrlPre
} from '@/api/account';
import E from 'wangeditor'

export default {
    model: {
        prop: "inContent", // 父组件设置v-model的变量值，v-model="message"
        event: "onchange" // 父组件监听message事件
    },
    name: 'textEditor',
    props: {
        editorId: {
            type: String,
            default: ''
        },
        inContent: {
            type: String,
            default: ''
        },
        zIndex: {
            type: Number,
            default: 1
        },
        height: {
            type: Number,
            default: 450
        }
    },
    watch: {
        inContent: function (e) {
            var vues = this;
            console.log('watch', e, this.isChange);
            if (!this.isChange) {
                this.$nextTick(() => {
                    setTimeout(() => {

                        // while(1){
                        //     if(vues.loadSuccess){
                        //         break;
                        //     }
                        // }
                        vues.editor.txt.html(e);
                        vues.isChange = false;
                        console.log('watch success');

                    }, 100)

                });

                // this.editorContent = e;
            }

        }
    },
    data() {
        return {
            editorContent: '',
            isChange: false,
            uploadImages: [],
            editor: {},
            loadSuccess: false,
        }
    },
    created: function () {
        var vues = this;
        if (this.inContent) {
            if (!this.isChange) {
                this.$nextTick(() => {

                    setTimeout(() => {
                        // var t = new Date().getTime();
                        // while(1){
                        //     if(vues.loadSuccess){
                        //         break;
                        //     }
                        // }
                        vues.editor.txt.html(vues.inContent);
                        vues.isChange = false;
                        console.log('created success');

                    }, 100)
                });
            }
        }
    },
    methods: {
        editorSet: function () {
            this.editor.$textContainerElem.css('height', this.height + 'px !important');
        },
    },
    mounted() {
        this.editor = new E(this.$refs.editor);
        var userInfo = this.$store.getters.userInfo;
        var vues = this;
        console.log('mounted', vues.isChange);

 
        Object.assign(this.editor.config, {
            zIndex: 1,
            customUploadImg: function (files, insertImgFn) {

                getFileToken({
                    userId: userInfo.userId,
                    fileType: 1
                }).then(res => {
                    imageUrlPre().then(urlPre => {
                  
                        res.imagePreUrl = urlPre.imagePreUrl;
                        uploadImg(files, res, insertImgFn, vues.$message.error);
                    });
                });
            },
            onchange: function (html) {
                console.log('onchange', html);
                vues.isChange = true;
                if (html == '<p><br></p>') {
                    // vues.editorContent = '';
                    vues.$emit('onchange', '');
                } else {
                    // vues.editorContent = html;
                    vues.$emit('onchange', html);
                }

            },
            // fontSizes: {
            //     'x-small': {
            //         name: '10px',
            //         value: '1'
            //     },
            //     'small': {
            //         name: '13px',
            //         value: '2'
            //     },
            //     'normal': {
            //         name: '16px',
            //         value: '3'
            //     },
            //     'large': {
            //         name: '18px',
            //         value: '4'
            //     },
            //     'x-large': {
            //         name: '24px',
            //         value: '5'
            //     },
            //     'xx-large': {
            //         name: '32px',
            //         value: '6'
            //     },
            //     'xxx-large': {
            //         name: '48px',
            //         value: '7'
            //     },
            // },
            fontNames: [
                // 对象形式 v4.6.16
                {
                    name: "黑体",
                    value: "黑体"
                },
                {
                    name: "仿宋",
                    value: "仿宋"
                },
                {
                    name: "楷体",
                    value: "楷体"
                },
                {
                    name: "标楷体",
                    value: "标楷体"
                },
                {
                    name: "华文仿宋",
                    value: "华文仿宋"
                },
                {
                    name: "华文楷体",
                    value: "华文楷体"
                },
                {
                    name: "宋体",
                    value: "宋体"
                },
                {
                    name: "微软雅黑",
                    value: "微软雅黑"
                },
                {
                    name: "绝绝字体",
                    value: "Times New Roman"
                },
                {
                    name: "Arial",
                    value: "Arial"
                },
                {
                    name: "Tahoma",
                    value: "Tahoma"
                },
                {
                    name: "Verdana",
                    value: "Verdana"
                },
                {
                    name: "Courier New",
                    value: "Courier New"
                },

            ]
        });

        this.editor.config.showFullScreen = true;

        this.editor.create();

        this.editorSet();

    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// textEditor.vue?d3097340